import React from 'react';
import { Alert, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { T } from '@transifex/react';

export const confirmUnsubscribeAll = () => {
  return new Promise((res) => {
    Modal.confirm({
      content: (
        <Alert
          message={<T _str="Unsubscribe from all notifications" />}
          description={
            <T _str="Are you sure you want to unsubscribe from notifications for all containers?" />
          }
          showIcon
          type="warning"
          style={{ backgroundColor: 'white' }}
          banner
        />
      ),
      icon: <div />,
      closeIcon: <CloseOutlined style={{ color: '#fff' }} />,
      closable: true,
      maskClosable: true,
      maskStyle: { backgroundColor: 'rgba(0,0,0,0.45)' },
      okText: <T _str="Confirm" />,
      okType: 'danger',
      onOk: () => res(true),
      onCancel: () => res(false),
    });
  });
};
